module.exports = __webpack_public_path__ + "img/facebook.fda3c9a0.png";